module.exports = __webpack_public_path__ + "static/img/areaA_10.5d066ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA_10.png
// module id = 979
// module chunks = 1